import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaStoreUtility from '@sparta.global.utilities/sparta-store-utility/dist/es6.js';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import spartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es6.js';
import benchmarkUtility from '@sparta.sales.utilities/benchmark-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';
import { link, layerContent } from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import '@sparta.global-tenants.utilities/gt-secure-fdic-utility/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <h1>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"h1") : stack1), depth0)) != null ? stack1 : "")
    + "</h1>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <h1>"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"metaTags") : depth0)) != null ? lookupProperty(stack1,"title") : stack1)) != null ? lookupProperty(stack1,"default") : stack1), depth0)) != null ? stack1 : "")
    + "</h1>\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "          <li>"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</li>\r\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"children") : depth0)) != null ? lookupProperty(stack1,"searchStub") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div id=\"dataJcr\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"schema") : stack1),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":52,"column":30},"end":{"line":52,"column":53}}}))
    + "\"></div>\r\n";
},"11":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"mobileLoginInterstitialModal") : stack1),{"name":"with","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":75,"column":0},"end":{"line":101,"column":9}}})) != null ? stack1 : "");
},"12":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"layerContent","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":76,"column":0},"end":{"line":100,"column":17}}})) != null ? stack1 : "");
},"13":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<img class=\"get-app-icon\" loading=\"lazy\" src=\""
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"getAppImg") : stack1), depth0)) != null ? stack1 : "")
    + "\">\r\n<h3 class=\"get-app-modal-title cnx-regular\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n<ul class=\"feature-list\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"items") : stack1),{"name":"each","hash":{},"fn":container.program(14, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":80,"column":2},"end":{"line":82,"column":11}}})) != null ? stack1 : "")
    + "</ul>\r\n<div class=\"discl-section row small-collapse\">\r\n  <div class=\"column small-1\">\r\n    <img class=\"lock-icon\" loading=\"lazy\" src=\""
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"lockImg") : stack1), depth0)) != null ? stack1 : "")
    + "\">\r\n  </div>\r\n  <div class=\"column small-11\">\r\n    <span class=\"discl-text\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"disclaimer") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n  </div>\r\n</div>\r\n"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"getAppNowButton") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n\r\n<a id=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data1") : depths[1])) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"hpGetTheAppModalContinue") : stack1)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\" href=\""
    + ((stack1 = container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"site") : depths[1])) != null ? lookupProperty(stack1,"staticwebLogin") : stack1), depth0)) != null ? stack1 : "")
    + "\"\r\n  class=\""
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data1") : depths[1])) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"hpGetTheAppModalContinue") : stack1)) != null ? lookupProperty(stack1,"CLASS") : stack1), depth0)) != null ? stack1 : "")
    + " spa-btn spa-btn--secondary spa-btn--block spa-btn--small\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data1") : depths[1])) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"hpGetTheAppModalContinue") : stack1)) != null ? lookupProperty(stack1,"content") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n</a>\r\n\r\n"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"maybeLaterButton") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "  <li>"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</li>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"ada-hidden\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"h1") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.program(3, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":6,"column":9}}})) != null ? stack1 : "")
    + "</div>\r\n\r\n<div id=\"gtSecureFdicWidgetContainer\"></div>\r\n\r\n<div class=\"main-nav-top-large-container\">\r\n  <div class=\"row\">\r\n    <div class=\"column large-12\">\r\n      <div class=\"main-nav-top-large\">\r\n        <ul role=\"navigation\" aria-label=\"Top menu\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"L1_NAV") : stack1)) != null ? lookupProperty(stack1,"posLeft") : stack1),{"name":"each","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":10},"end":{"line":18,"column":19}}})) != null ? stack1 : "")
    + "        </ul>\r\n        <ul role=\"navigation\" aria-label=\"Top menu\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"L1_NAV") : stack1)) != null ? lookupProperty(stack1,"posRight") : stack1),{"name":"each","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":10},"end":{"line":23,"column":19}}})) != null ? stack1 : "")
    + "        </ul>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"main-nav-top-logo\" itemscope itemtype=\"http://schema.org/Corporation\">\r\n  <div class=\"logo-container\">\r\n    <img src=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"boaLogo") : stack1), depth0))
    + "\" loading=\"lazy\" alt=\""
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"boaLogoAlt") : stack1), depth0)) != null ? stack1 : "")
    + "\" itemprop=\"logo\" />\r\n    <a href=\"https://www.bankofamerica.com\" itemprop=\"url\" class=\"hidden\"></a>\r\n  </div>\r\n  <span itemprop=\"brand\" class=\"ada-hidden\" aria-hidden=\"true\">Bank of America</span>\r\n  <div class=\"search large-search\" id=\"search\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"children") : depth0)) != null ? lookupProperty(stack1,"searchStub") : stack1),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":37,"column":4},"end":{"line":39,"column":11}}})) != null ? stack1 : "")
    + "  </div>\r\n  <div class=\"hide-for-large-up mobile-login-container hide\">\r\n    "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"LOGIN_SMALL") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":42,"column":4},"end":{"line":42,"column":38}}})) != null ? stack1 : "")
    + "\r\n    "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"LOGIN_MEDIUM") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":43,"column":4},"end":{"line":43,"column":39}}})) != null ? stack1 : "")
    + "\r\n    <a href=\"javascript:void(0);\" class=\"close-top-nav menu-icon menu-icon--htx\" role=\"button\" aria-expanded=\"false\"\r\n      aria-controls=\"headerMenuContainer\">\r\n      <span>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"toggleMenuADA") : stack1), depth0))
    + "</span>\r\n    </a>\r\n  </div>\r\n</div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"schema") : stack1),{"name":"if","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":51,"column":0},"end":{"line":53,"column":7}}})) != null ? stack1 : "")
    + "\r\n<div id=\"headerMenuContainer\" class=\"menu-container hide-for-large-up\" aria-hidden=\"true\">\r\n  <div class=\"search row small-collapse full-width-row\">\r\n    <div class=\"small-search\">\r\n      <div class=\"header-search\" data-rwd-content=\"search\" data-rwd-content-rule=\"not-large\"></div>\r\n    </div>\r\n  </div>\r\n  <div class=\"menu-contents\">\r\n    <div class=\"small-nav row\">\r\n      <div class=\"column medium-10 medium-push-1\">\r\n        <ul class=\"main-nav-top-items\" role=\"navigation\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"L1_NAV") : stack1)) != null ? lookupProperty(stack1,"medium") : stack1),{"name":"each","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":65,"column":10},"end":{"line":67,"column":19}}})) != null ? stack1 : "")
    + "        </ul>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":74,"column":0},"end":{"line":102,"column":7}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.homepage.modules/header-module",
  "version": "2.0.3",
  "id": "headerModule",
  "containerID": "homepageHeaderModule",
  "moduleName": "homepage-header-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "main",
  "nameSpace": "header-module",
  "data": {
    "init": "headerModuleJS",
    "options": {}
  },
  "moduleParams": [{
    "name": "showGetAppModalForMobileLogin",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "pass true to pop interstitial modal asking user to get app when clicking login in mobile devices"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        json,
        link,
        layerContent
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    json,
    link,
    layerContent
  },
  "dependencies": {
    "@sparta.global-tenants.utilities/gt-secure-fdic-utility": "^1.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-store-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.8",
    "@sparta.global.utilities/sparta-ui-layers-utility": "^1.0.0",
    "@sparta.sales.utilities/benchmark-utility": "^1.0.0"
  },
  "stores": []
};

/* eslint-disable no-console */

/* eslint-disable no-console */

/**
 * module_js_id: headerModuleJS
 */
class headerModuleJS extends Module {
  /**
   * @description Creates an instance of headerModuleJs
   * @method constructor
   * @param {Object} options options
   * @param {Object} context context
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    const {
      target
    } = this.settings;
    this.mq = window.matchMedia('(min-width: 1025px)');
    this.navLinks = target.querySelectorAll('ul li');
    if (spaParams.siteParams.jsTimer) {
      benchmarkUtility.init(this);
    }
  }

  /**
   * Initializer
   * @returns { void }
   */
  init() {
    this.scriptTagsCreation();
    this.bindTopNavClose();
    this.bindNavLinks();
    this.bindTransitionEvents();
    this.bindMediumLoginLink();
    this.bindSmallLoginLink();
    this.mediumLoginBlur();
    this.addAdaHiddenSelectedText();
    this.checkLoginUserAgent();

    // Prevents FOUC on page load
    this.mobileLoginContainerEl = this.settings.target.querySelector('.mobile-login-container');
    this.Events.sub('SPARTA_GLOBAL_READY/spartaBootstrapUtility', data => {
      this.mobileLoginContainerEl.classList.remove('hide');
    }, true);
  }
  //removed script tags from hbs and re-created using js
  scriptTagsCreation() {
    const dataJcrDiv = this.settings.target.querySelector('#dataJcr');
    if (dataJcrDiv) {
      const jsonSchema = dataJcrDiv.dataset.jcr;
      const script = document.createElement('script');
      script.setAttribute('type', 'application/ld+json');
      script.textContent = jsonSchema;
      dataJcrDiv.insertAdjacentElement("afterend", script);
    }
  }

  /**
   * Bind close navigation links
   *
   * @testExample bindTopNavClose()
   * @testOutput equal undefined
   * @testTrigger click mockedElements[2]
   * @testExpect mockedContainerElement.classList.contains('active') toEqual true
   * @mockElement #headerMenuContainer <div class="search"></div>
   * @mockElement a#LOGIN_MEDIUM
   * @mockElement a.close-top-nav
   * @returns { void }
   */
  bindTopNavClose() {
    const {
      target
    } = this.settings;
    const closeElem = target.querySelector('.close-top-nav');
    closeElem.addEventListener('click', this.toggleActive.bind(this));
  }

  /**
   * Toggles the 'active' class on an element
   * @param {Event} e Element to have the 'active' class toggled on
   * @returns { void }
   */
  toggleActive(e) {
    const {
      target
    } = this.settings;
    const menuContainer = document.getElementById('headerMenuContainer');
    const menuCta = e.currentTarget;
    const isActive = target.classList.contains('active');
    const searchContainer = menuContainer.querySelector('.search');
    const loginLink = this.settings.target.querySelector('#LOGIN_MEDIUM');
    const loginActive = loginLink.getAttribute('aria-expanded') === 'true';
    target.classList.toggle('active');

    // ADA - set aria attribs
    menuContainer.setAttribute('aria-hidden', isActive ? 'true' : 'false');
    menuCta.setAttribute('aria-expanded', isActive ? 'false' : 'true');

    // ADA - this needs to always be display block when toggling menu - see bind transition events
    searchContainer.style.display = 'block';

    // Hide the sign in box
    if (!isActive && loginActive) {
      loginLink.click();
    }
  }

  /**
   * Binds transition events to hide the search so it's not focused when menu is collapsed
   * @returns { void }
   */
  bindTransitionEvents() {
    const {
      target
    } = this.settings;
    const menuContainer = document.getElementById('headerMenuContainer');
    const searchContainer = menuContainer.querySelector('.search');
    ['webkitTransitionEnd', 'otransitionend', 'msTransitionEnd', 'transitionend'].forEach(event => {
      target.addEventListener(event, e => {
        if (e.propertyName === 'opacity') {
          searchContainer.style.display = target.classList.contains('active') ? 'block' : 'none';
        }
      });
    });
  }

  /**
   * Bind main navigation links.
   * @returns { void }
   */
  bindNavLinks() {
    Array.from(this.navLinks).forEach(navLink => {
      navLink.addEventListener('click', this.navLinkHandler.bind(this));
    });
  }

  /**
   * Event listener to show and hide the sign in module.
   *
   * @testExample bindMediumLoginLink()
   * @testOutput equal undefined
   * @testTrigger click mockedElements[0]
   * @testExpect mockedElements[0].getAttribute('aria-expanded') toEqual 'true'
   * @testTrigger click mockedElements[0]
   * @testExpect mockedElements[0].getAttribute('aria-label') toEqual 'Close'
   * @mockElement a#LOGIN_MEDIUM <span data-login="Login" data-close="Close"></span>
   * @mockElement .menu-icon
   * @returns {void}
   */
  bindMediumLoginLink() {
    const loginLink = this.settings.target.querySelector('#LOGIN_MEDIUM');
    const loginSpan = loginLink.querySelector('span');
    let loginText;
    let closeText;
    if (typeof loginSpan.dataset !== 'undefined') {
      loginText = loginSpan.dataset.login;
      closeText = loginSpan.dataset.close;
    } else {
      loginText = loginSpan.getAttribute('data-login');
      closeText = loginSpan.getAttribute('data-close');
    }

    // Since the link helper doesn't support arbitrary attributes, need to set it
    loginLink.setAttribute('aria-expanded', 'false');
    loginLink.setAttribute('aria-controls', 'signInModule');
    loginLink.setAttribute('aria-label', loginText);
    loginLink.addEventListener('click', e => {
      e.preventDefault();
      const expanded = loginLink.getAttribute('aria-expanded') === 'true';

      // Check if it's expanded, and check if the hamburger menu link is active or not.
      if (!expanded) {
        const menuCta = this.settings.target.querySelector('.menu-icon');
        const menuExpanded = menuCta.getAttribute('aria-expanded') === 'true';
        if (menuExpanded) {
          menuCta.click();
        }
        loginLink.setAttribute('aria-label', closeText);
      } else {
        loginLink.setAttribute('aria-label', loginText);
      }
      loginLink.setAttribute('aria-expanded', !expanded);
      this.Events.pub('mediumLoginState', {
        expand: !expanded
      }, true);
      loginLink.focus();
    });
    loginLink.addEventListener('blur', () => {
      if (loginLink.getAttribute('aria-expanded') === 'true') {
        this.Events.pub('mediumLoginFocus', {}, true);
      }
    });
  }

  /**
   * Remove selected class from navigation link.
   * @returns { void }
   */
  removeSelectedNavLinks() {
    Array.from(this.navLinks).forEach(linkWrapper => {
      linkWrapper.classList.remove('selected');
    });
  }

  /**
   * Handler for the nav link event.
   * @param {Event} event event to target
   * @returns { void }
   */
  navLinkHandler(event) {
    if (!this.mq.matches) return;
    this.removeSelectedNavLinks();
    event.currentTarget.classList.add('selected');
  }

  /**
   * Medium login blur for - ADA
   *
   * @testExample mediumLoginBlur()
   * @testOutput undefined
   * @testTrigger blur mockedElements[0]
   * @testExpect this.Events.pub.called toEqual true
   * @spy this.Events.pub
   * @mockElement button#LOGIN_MEDIUM[aria-expanded="true"]
   * @returns {void}
   */
  mediumLoginBlur() {
    const loginMedium = document.getElementById('LOGIN_MEDIUM');
    loginMedium.addEventListener('blur', () => {
      const expanded = loginMedium.getAttribute('aria-expanded');
      if (expanded === 'true') {
        this.Events.pub('mediumLoginState', {
          expand: true
        }, true);
      }
    });
  }

  /**
   * Bind events for 'Get The App' and 'Continue' buttons
   * @returns {void}
   */
  bindSmallLoginLink() {
    const hideModalUntil = this.Store.getPersisted('hideGetTheAppModal');
    if (!hideModalUntil || hideModalUntil.until < Date.now()) {
      if (hideModalUntil) {
        // 14 days have passed, remove cookie
        this.Store.removePersisted('hideGetTheAppModal');
      }
      document.getElementById('LOGIN_SMALL').addEventListener('click', e => {
        e.preventDefault();
        const hpGetAppModalContainer = document.getElementById('hpGetTheAppModalSpartaUILayer');
        if (hpGetAppModalContainer && hpGetAppModalContainer.classList.contains('spa-ui-modal-interstitial')) {
          hpGetAppModalContainer.classList.remove('spa-ui-modal-interstitial');
        }
        spartaUILayersUtility.openLayer('#hpGetTheAppModal');
      });
      this.subToModalOpenSetFocus(); // ADA focus on modal close over ride
      this.settings.target.querySelector('#hpGetTheAppModalOpen').addEventListener('click', this.openGetAppModal.bind(this));
      this.settings.target.querySelector('#hpGetTheAppModalContinue').addEventListener('click', this.continueHandler.bind(this));
    }
  }

  /**
   * Publish event to open global get-app modal
   *
   * @testExample openGetAppModal()
   * @testOutput undefined
   * @testExpect this.Events.pub.called toEqual true
   * @spy this.Events.pub
   * @param { Event } e event
   * @returns {void}
   */
  openGetAppModal(e) {
    this.Events.pub('OPEN.globalGetAppModal', e);
  }

  /**
   * Set cookie in localStorage to hide popup for 14 days
   *
   * @testExample continueHandler()
   * @testOutput undefined
   * @testExpect this.Store.getPersisted('hideGetTheAppModal') toExist
   * @mockLocalStorage
   * @mockUrl ?expireTime=1
   * @returns {void}
   */
  continueHandler() {
    // Add potential for testing url param - number of minutes
    if (this.SpartaFunctions.getUrlParam('expireTime')) {
      const testExpireTime = new Date(Date.now() + 60000 * parseInt(this.SpartaFunctions.getUrlParam('expireTime'), 10)).getTime();
      this.Store.persist('hideGetTheAppModal', {
        until: testExpireTime
      });
    } else {
      // 12096e5 is a magic number for 14 days in milliseconds
      const expireTime = new Date(Date.now() + 12096e5).getTime();
      this.Store.persist('hideGetTheAppModal', {
        until: expireTime
      });
    }
  }

  /**
   * Add ada hidden "Selected" text to link
   * @returns {void}
   */
  addAdaHiddenSelectedText() {
    const selectedEl = this.settings.target.querySelector('.selected');
    if (selectedEl) {
      const adaSpan = document.createElement('span');
      adaSpan.classList.add('ada-hidden');
      adaSpan.innerHTML = '&nbsp; Selected';
      selectedEl.appendChild(adaSpan);
    }
  }

  /**
   * Sub SpartaBrowserSupportUtility to detect IE useragent or desktop configuration.
   * Call rewriteLoginUrl() if IE or desktop.
   *
   * @returns {void}
   */
  checkLoginUserAgent() {
    spartaEventsUtility.sub('LOADED.SpartaBrowserSupportUtility', () => {
      const browserInfo = spartaStoreUtility.getData('browser');
      if (!browserInfo) return;
      const isIE = browserInfo.msie;
      const isDesktop = browserInfo.desktop;

      // Staticweb login is not compatible with IE. Route IE users to Borneo signin.
      // Staticweb login link appears on desktop with sufficient zoom. Route to Borneo signin.
      if (isIE || isDesktop) {
        const secureHost = spaParams.siteParams.secureHost ? spaParams.siteParams.secureHost : 'https://secure.bankofamerica.com';
        this.rewriteLoginUrl(['#hpGetTheAppModalContinue', '#LOGIN_SMALL'], `${secureHost}/login/sign-in/signOnV2Screen.go`);
      }
    }, true // retroactive - trigger immediate callback when event has been published before sub().
    );
  }

  /**
   * Rewrite an anchor's href, given the anchor's selector and href string.
   *
   * @param {Array} anchorSelector array of anchor selectors to point to loginUri
   * @param {String} loginUri URL for the Borneo login page
   * @returns {void}
   */
  rewriteLoginUrl(anchorSelector, loginUri) {
    if (!anchorSelector || anchorSelector.length === 0 || !loginUri) return;
    for (let i = 0; i < anchorSelector.length; i++) {
      const el = this.settings.target.querySelector(anchorSelector[i]);
      if (el) {
        el.href = loginUri;
      }
    }
  }

  /**
   *ADA workaround for platform timeout issue - overrides focus on X for small screen login modal
   *@returns {void}
   */
  subToModalOpenSetFocus() {
    spartaEventsUtility.sub(spartaUILayersUtility.EVENTS.MODAL_OPENED, () => {
      const closeButton = document.querySelector('.spa-ui-layer-close');
      closeButton.focus();
    });
  }
}
registerModuleClass({
  moduleClass: headerModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { headerModuleJS as default, moduleConfig };
